import type { AxiosInstance, AxiosRequestConfig } from 'axios';
import axios from 'axios';

interface RequestConfig {
  headers?: Record<string, string>;
  params?: Record<string, string | number | boolean>;
}

interface Response<T> {
  raw: T;
  status: number;
}

export class HTTPClient {
  private instance: AxiosInstance;

  public constructor(
    baseURL: string,
    config: AxiosRequestConfig = {},
    options?: AxiosRequestConfig,
  ) {
    config.withCredentials = true;

    this.instance = axios.create({
      baseURL,
      ...config,
      ...options,
    });
  }

  public getInstance(): AxiosInstance {
    return this.instance;
  }

  public async get<T = unknown>(
    url: string,
    config?: RequestConfig,
  ): Promise<Response<T>> {
    const response = await this.instance.get<T>(url, config);

    return {
      raw: response.data,
      status: response.status,
    };
  }

  public async post<T = unknown>(
    url: string,
    data?: T,
    config?: RequestConfig,
  ): Promise<Response<T>> {
    const response = await this.instance.post<T>(url, data, config);

    return {
      raw: response.data,
      status: response.status,
    };
  }
}
